import { useForm } from 'react-hook-form';
import { useAlert } from 'shared/components/alerts';
import { DocumentModel } from '@types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { resolveContractMinutes } from 'shared/utils/resolve-contract-minutes';
import { useCreateSignDocumentFormSchema } from './use-create-sign-document-form-schema';
import { useSignDocument } from './use-sign-document';

export const useDocumentDialogSign = (
  documentId: string,
  onClose: () => void,
  formDataModel: DocumentModel[string],
  contractMinutes: number,
  workerId: string
) => {
  const { formSchema, defaultValues: dynamicDefaultValues } =
    useCreateSignDocumentFormSchema(formDataModel);
  const { mutate, isLoading } = useSignDocument();
  const { alertError, alertSuccess } = useAlert();
  const { t } = useTranslation('hq-screen-specific');

  const methods = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      documentId,
      ...dynamicDefaultValues,
      contractHours: Math.round((contractMinutes / 60) * 10) / 10,
    },
  });

  const handleSubmit = methods.handleSubmit(() => {
    const { documentId, contractHours: _contractHours, ...dynamicProperties } = methods.getValues();
    const contractMinutes = resolveContractMinutes(_contractHours) ?? 0;
    mutate(
      { documentId, dynamicProperties, contractMinutes, workerId },
      {
        onSuccess: () => {
          alertSuccess(
            t('documents.sign_dialog.sign_success_message', { ns: 'hq-screen-specific' })
          );
          onClose();
        },
        onError: (e) => alertError(e),
      }
    );
  });

  return { methods, handleSubmit, isLoading };
};
